module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"beforeTitle":"Customer testimonials","title":"Satisfied customers","readMore":"Read more"},"fr":{"beforeTitle":"Témoignages clients","title":"Des clients satisfaits","readMore":"Lire plus"}}')
  delete Component.options._Ctor
}
